import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTenant } from '../../../contexts/TenantContext';

const AuthLink = ({ to, children, sx = {} }) => {
  const { displayConfig } = useTenant();

  return (
    <Link component={RouterLink} to={to} underline="always" sx={{ color: displayConfig?.color, fontWeight: "bold", ...sx }}>
      {children}
    </Link>
  );
};

export default AuthLink;
